import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// middlewares

import PurchaseRequestMiddleware from "../../../middleware/modules/purchasing/purchase-request";
import PrintPR from "../../../components/utilities/print/default/pr";

const mapStateToProps = ({ auth, purchaserequest }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: purchaserequest.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  dataPrint: purchaserequest.printPr,
  requestPrint:purchaserequest.requestPrintPr
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => PurchaseRequestMiddleware.getPrint(id),
    },
    dispatch
  );
};

class PrContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.prid);
  }

  render() {
    return <PrintPR {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrContainer);
